export const EDIT_PROFILE = {
    DEFAULT_LANGUAGE: 'en',
    DEFAULT_TIME_FORMAT: '12',
    DEFAULT_MEASUREMENT: 'metric',
    TIME_FORMAT_SETTING: 'TIME_FORMAT_SETTING'
  };
  